<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group [title]="'wbo.order-assignment-rule.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column formGroupName="preparationOutlet">
                        <wbo-outlet-single-select-edit-control formControlName="outletId"
                                                               [(ngModel)]="model.data.preparationOutlet.outletId"
                                                               [objectValue]="model.data.preparationOutlet">
                        </wbo-outlet-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
        <fui-rows [formGroup]="editPage.formGroup" [label]="'wbo.order-assignment-rule.edit.field-set.filter'">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-meta-tag-multi-select-edit-control formControlName="tags"
                                                                [(ngModel)]="model.data.tags"
                                                                [type]="MetaTagType.DOCKET_SELECTOR"
                                                                [extendedEditComponentParams]="{type: MetaTagType.DOCKET_SELECTOR}"
                                                                [extendedSearchComponentParams]="{type: MetaTagType.DOCKET_SELECTOR}"
                                                                [multiObjectValueType]="true">
                        </wbo-meta-tag-multi-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-column>
                            <wbo-outlet-multi-select-edit-control formControlName="outlets"
                                                                  [(ngModel)]="model.data.outlets"
                                                                  [multiObjectValueType]="true">
                            </wbo-outlet-multi-select-edit-control>
                        </fui-column>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-order-type-multi-select-edit-control formControlName="orderTypeIds"
                                                                  [(ngModel)]="model.data.orderTypeIds">
                        </wbo-order-type-multi-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="includeCompositeItems"
                                                   [(ngModel)]="model.data.includeCompositeItems"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
